import React,{useState} from 'react';
import '../../App.css';
import FormSignup from '../FormSignup'


function Bilty({ sessionObject, itemNamesDict }) {
  if(!sessionObject.sessionVariables["modules"].includes("bilty")){
    return;}
    let crossing = false
    return (
      <div className="page-bilty">
        <FormSignup crossingVal={crossing} sessionObject={sessionObject} itemNamesDict={itemNamesDict} />
      </div>
    );
}

export default Bilty;